import { render, staticRenderFns } from "./AddEditForm.vue?vue&type=template&id=1b7278c8&scoped=true"
import script from "./AddEditForm.vue?vue&type=script&lang=js"
export * from "./AddEditForm.vue?vue&type=script&lang=js"
import style0 from "./AddEditForm.vue?vue&type=style&index=0&id=1b7278c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7278c8",
  null
  
)

export default component.exports